export default __webpack_public_path__ + "static/media/15.50542fd4.jpg";